import HBMessage from "@/components/HBMessage";
import axios from "axios";
import request, { env } from "../utils/request";

export async function getCategories() {
  return request({
    url: "/categories",
    ignoreError: true,
  });
}
/**
 * https://yapi.gaoding.com/project/1536/interface/api/115801
 * @param {string|File}file {File}
 * @param onUploadProgress {(e: Event) => void}
 * @returns {Promise<IPinFile>}
 */
export function uploadFile(file, onUploadProgress = null, signal = null) {
  const data = new FormData();
  data.append("file", file);
  return request({
    method: "post",
    url: "/upload",
    data,
    timeout: 0,
    ignoreCancel: true,
    onUploadProgress,
    ...(signal ? { signal } : null),
  });
}

/**
 * 获取用户相关信息
 * https://yapi.gaoding.com/project/1536/interface/api/118271
 * @returns {Promise<*>}
 */
export function getMyMuseStatus() {
  return request({
    url: "/muse/me/status",
  });
}
/**
 * 举报
 * @returns {Promise<*>}
 */
export function report({ type, reason, detail, id }) {
  return request({
    method: "post",
    url: "/feedback/new-report/",
    data: {
      type,
      reason,
      detail,
      id,
    },
    ignoreMessage: true,
  });
}
/**
 * 获取为你推荐
 * @returns {Promise<*>}
 */
export function getRecommends() {
  return request({
    url: "/error/msg",
  });
}
/**
 * 获取杂货店数据
 * @template T
 * @returns {Promise<T>}
 */
export function getGrocery(
  path,
  {
    serverSide = false,
    mute = false,
    project = "huaban",
    disableCache = false,
  } = {}
) {
  const host = serverSide
    ? `http://gaoding-grocery.oss-cn-hangzhou.aliyuncs.com/${project}`
    : `https://grocery-cdn.huaban.com/${project}`;

  let pathUrl = `${host}/${path}${env === "prod" ? "" : "." + env}.json`;
  if (disableCache) {
    pathUrl += `?_time=${Date.now()}`;
  }

  return axios
    .get(pathUrl)
    .then((res) => res.data)
    .catch(() => {
      if (!mute || !serverSide) {
        HBMessage.error("获取数据失败");
      }
    });
}
/**
 *  保存用户页面配置信息
 * @returns {Promise<*>}
 */
export function savePageSetting(configs) {
  return request({
    method: "PUT",
    url: "/users/configs",
    data: {
      configs,
    },
  });
}

/**
 *  保存用户页面配置信息
 * @returns {Promise<*>}
 */
export function getWechatSignature({ url }) {
  return request({
    url: "/wechat/config",
    query: {
      url,
    },
  });
}

/**
 * 拉黑
 * @param {Object} data
 * @param {number} data.item_type 拉黑对象类型 1:file; 2:board; 3:user; 4:domain
 * @param {number} data.item_value 拉黑对象具体的值：采集id，画板id，用户id，域名
 * @returns {AxiosPromise}
 */
export function toBlackList(data) {
  return request({
    method: "post",
    url: "/users/blacklists",
    data,
  });
}

/**
 * 取消拉黑
 * @param {Object} data
 * @param {number} data.item_type 拉黑对象类型 1:file; 2:board; 3:user; 4:domain
 * @param {number} data.item_value 拉黑对象具体的值：采集id，画板id，用户id，域名
 * @returns {AxiosPromise}
 */
export function outBlackList(data) {
  return request({
    method: "delete",
    url: "/users/blacklists",
    data,
  });
}

/**
 * 获取用户黑名单列表
 * @param {Object} data
 * @param {number} data.item_type 拉黑对象类型 1:file; 2:board; 3:user; 4:domain
 * @returns {AxiosPromise<{
 *  blacklist_id: number,
 * }>}
 **/
export function getBlackList({ item_type }) {
  return request({
    url: "/users/blacklists",
    query: {
      item_type,
    },
  });
}

/**
 * 检测是否被拉黑
 * @param {Object} data
 * @param {number} data.item_type 拉黑对象类型 1:file; 2:board; 3:user; 4:domain
 * @param {number} data.item_value 拉黑对象具体的值：采集id，画板id，用户id，域名
 * @returns {AxiosPromise}
 */
export function checkBlackList(data) {
  return request({
    url: "/users/is_blacklist",
    query: data,
  });
}
